import { render, staticRenderFns } from "./ProductListingIndex.vue?vue&type=template&id=83025886&"
import script from "./ProductListingIndex.vue?vue&type=script&lang=js&"
export * from "./ProductListingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports